import Axios from 'axios';


var headers = {
    'Content-Type': 'application/json',

}
export default {


    getAll() {
        //console.log(BASE_URL)
        const BASE_URL = '/public/api';
        return Axios.get(BASE_URL + '/items', { headers: headers })
    },

    create(data) {
        const BASE_URL = '/public/api';
        return Axios.post(BASE_URL + '/items', data, { headers: headers });

    },

    update(id, data) {
        const BASE_URL = '/public/api';
        return Axios.put(BASE_URL + '/items/' + id, data, { headers: headers });
    },

    delete(id) {
        const BASE_URL = '/public/api';
        return Axios.delete(BASE_URL + '/items/' + id, { headers: headers });
    },

}